import { render, staticRenderFns } from "./tab2.vue?vue&type=template&id=129ee68e&scoped=true&"
import script from "./tab2.vue?vue&type=script&lang=js&"
export * from "./tab2.vue?vue&type=script&lang=js&"
import style0 from "./tab2.vue?vue&type=style&index=0&id=129ee68e&prod&lang=css&"
import style1 from "./tab2.vue?vue&type=style&index=1&id=129ee68e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129ee68e",
  null
  
)

export default component.exports